import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const useHttpExamplesPageRoute: RouteConfig<'with-page'> = {
    name: 'useHttp Examples',
    path: '/use-http-examples',
    page: lazy(() => import('.')),
    icon: 'mdi mdi-language-html5',
    roles: ['developer'],
}